module.exports = __webpack_public_path__ + "static/img/13.faa1d10.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/13.png
// module id = uvcZ
// module chunks = 6